import SVG from "react-inlinesvg";
import { RWebShare } from "react-web-share";
import { decodeHtmlEntitiesSSR } from "@/utils/stringHelper";
import sendGAEvent from "@/utils/gaEvent";

const index = ({
  title,
  url,
  customText,
  contentType = "story",
  sites = [
    "copy",
    "facebook",
    "twitter",
    "whatsapp",
    "mail",
    "linkedin",
    "reddit",
  ],
  isRajasthan,
  isMadhya,
  isHR = false, isUP = false,
  isBH = false,
  isCGH = false,
  isUK = false,
  isBiz = false,
  isPB = false,
  onShareClick,
}) => {
  return (
    <div
      onClick={() => {
        sendGAEvent({
          eventName: "Share Button",
          pageTitle: title,
          pageLocation: url,
        });
      }}
      className="flex items-center justify-center space-x-1 my-2 "
    >
      <style jsx global>{`
        .rws-icon {
          width: 40px !important;
          height: 40px !important;
          cursor: pointer;
          border: 0;
          background: #1a78f6;
          padding: 0.5rem;
          border-radius: 0.5rem;
          font-size: 0;
        }

        .rws-icons {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          grid-gap: 0.25rem !important;
        }

        .rws-header {
          font-size: 16px !important;
        }
      `}</style>

      <RWebShare
        data={{
          text: customText
            ? decodeHtmlEntitiesSSR(customText)
            : decodeHtmlEntitiesSSR(title),
          url: url,
          title: decodeHtmlEntitiesSSR(title),
        }}
        sites={sites}
      >
        <SVG
          className={`h-8 w-8 ${isRajasthan ? 'text-rajasthanDark' : isMadhya ? 'text-mpDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isCGH ? 'text-mpDark' : isUK ? "text-ukDark" : isBiz ? 'text-bizDark' : isPB ? 'text-pbDark' : 'text-primary'}`}
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/share.svg"
        />
      </RWebShare>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          url
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-FacebookShare"
                : "ArticlePage-FacebookShare",
            pageTitle: title,
            pageLocation: url,
          });
          onShareClick?.("facebook");
        }}
      >
        <SVG
          className="h-8 w-8 bg-[#337FFF] rounded-full p-2"
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/facebook.svg"
        />
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-WhatsAppShare"
                : "ArticlePage-WhatsAppShare",
            pageTitle: title,
            pageLocation: url,
          });
          onShareClick?.("whatsapp");
        }}
      >
        <SVG
          className="h-8 w-8"
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/whatsapp.svg"
        />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          url
        )}&title=${title ?? ""}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Twitter"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-TwitterShare"
                : "ArticlePage-TwitterShare",
            pageTitle: title,
            pageLocation: url,
          });
          onShareClick?.("twitter");
        }}
      >
        {/* <img
          className="h-8 w-8 bg-gray-200 rounded-full p-1"
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/tw.svg"
          alt="social share"
           loading="eager"
          width={32}
          height={32}
        /> */}
        <svg width="33" height="32" viewBox="0 0 101 100" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8"><path opacity="0.1" d="M98.2221 50C98.2221 76.3869 76.8313 97.7778 50.4443 97.7778C24.0574 97.7778 2.66656 76.3869 2.66656 50C2.66656 23.6131 24.0574 2.22222 50.4443 2.22222C76.8313 2.22222 98.2221 23.6131 98.2221 50Z" stroke="currentColor" strokeWidth="4.44444"></path><path fillRule="evenodd" clipRule="evenodd" d="M33.7773 35.5556H47.5551L53.9579 45.5556L62.8885 35.5556H68.2218L56.4162 48.8889L69.3329 66.6667H56.6662L49.3329 56.6667L39.5551 66.6667H33.7773L45.9996 53.3334L33.7773 35.5556ZM58.2218 63.3334L40.9996 38.8889H44.8885L62.6662 63.3334H58.2218Z" fill="currentColor"></path></svg>
      </a>
    </div>
  );
};

export default index;
